<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Auto collateral details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row mt-3">
      <div class="col-sm-6">
        <fmc-car-search
          [placeholderText]="'Car search'"
          [parentFormGroup]="formGroup"
          [controlName]="'vehicle'"
        ></fmc-car-search>
      </div>
      <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <input matInput placeholder="VIN" formControlName="vin">
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'vin'"></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
